import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";

import HelpButton from "../Components/Other Components/helpButton";
import { useTutorial } from "../Contexts/TutorialContext";

const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

const pageTransition = {
  duration: 0.2,
};

function PageWrapper({
  children,
  className = "",
  variants = pageVariants,
  transition = pageTransition,
  tutorialId,
  tutorialSteps,
}) {
  const location = useLocation();
  const { maybeAutoStart, startTutorial } = useTutorial();

  const hasTutorial = Boolean(tutorialId && tutorialSteps?.length);

  useEffect(() => {
    if (!hasTutorial) return;
    // Small delay so the page's own content (and anything it fetches) has
    // a chance to mount before the tour tries to measure target elements.
    const timer = setTimeout(() => {
      maybeAutoStart(tutorialId, tutorialSteps);
    }, 500);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tutorialId, hasTutorial]);

  return (
    <motion.div
      className={`page ${className}`}
      initial="initial"
      animate="animate"
      exit="exit"
      variants={variants}
      transition={transition}
      key={location.pathname}
    >
      {children}
      {hasTutorial && (
        <HelpButton
          onClick={() =>
            startTutorial(tutorialId, tutorialSteps, { isReplay: true })
          }
        />
      )}
    </motion.div>
  );
}

export default PageWrapper;
